import { render, staticRenderFns } from "./PatientNewView.vue?vue&type=template&id=a809535c&scoped=true"
import script from "./PatientNewView.vue?vue&type=script&lang=ts"
export * from "./PatientNewView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a809535c",
  null
  
)

export default component.exports